var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submission",style:(_vm.style)},[(_vm.isText)?_c('TextSubmission',{attrs:{"text":_vm.title}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }